import { useMemo, useState } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { InputGroup } from 'react-bootstrap';
import useLocalization from '../../hooks/useLocalization';
import DecimalInput from './DecimalInput';

const monthsToYearsRounded = months => {
  const year = Math.floor(months / 12);
  const remainingMonths = Math.round(months % 12);
  return parseFloat((year + remainingMonths / 12).toFixed(2));
};

const yearsToMonthsRounded = years => Math.round(years * 12);

const units = [
  { value: 'month', label: 'months' },
  { value: 'year', label: 'years' }
];

const MonthYearInput = ({ value, onChange }) => {
  const [mode, setMode] = useState('year');
  const yearValue = useMemo(() => monthsToYearsRounded(value), [value]);
  const { translate } = useLocalization();

  return (
    <div className="d-flex align-items-center py-1 w-100 gap-1">
      <InputGroup size="sm" className="flex gap-1">
        <DecimalInput
          className="border border-gray-300 px-2"
          value={mode === 'month' ? Number(value) || 0 : yearValue}
          onChange={mode === 'month' ? onChange : y => onChange(yearsToMonthsRounded(y))}
        />
        <Select value={mode} onValueChange={setMode}>
          <SelectTrigger className="w-[90px] rounded-none p-2 shadow-none m-0">
            <SelectValue placeholder="Select option" />
          </SelectTrigger>
          <SelectContent className="bg-white rounded-none p-0 m-0">
            {units.map(unit => (
              <SelectItem
                className={`hover:bg-gray-100 transition-colors rounded-none m-0 ${
                  unit.value === mode ? '!bg-blue-100 !text-blue-700 font-medium' : ''
                }`}
                key={unit.value}
                value={unit.value}
              >
                {translate(unit.label) || unit.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </InputGroup>
    </div>
  );
};

export default MonthYearInput;
